"use strict";var e=require("@apollo/client"),t=require("./validationIssue.fragment-cjs-Cw-mgojl.js"),a=require("react"),i=e.gql`
  ${t.C}
  ${t.a}
  ${t.V}
  mutation AddProductsToEcommerceCart(
    $addProductsToCartInput: AddProductsToCartInput!
  ) {
    addProductsToEcommerceCart(
      addProductsToCartInput: $addProductsToCartInput
    ) {
      cart {
        id
        operationalModel
        status
        products {
          ...CartProduct
        }
        specialProducts {
          ...CartSpecialProduct
        }
      }
      confirmationStatuses {
        reference
        validationIssues {
          ...validationIssue
        }
      }
    }
  }
`,o=e.gql`
  mutation GenerateBackofficeToken(
    $generateBackofficeTokenInput: GenerateBackofficeTokenInput!
  ) {
    generateBackofficeToken(
      generateBackofficeTokenInput: $generateBackofficeTokenInput
    ) {
      token
    }
  }
`,n=e.gql`
  query GetQuotations($getQuotationsInput: GetQuotationsInput!) {
    getQuotations(getQuotationsInput: $getQuotationsInput) {
      id
      status
      customer {
        id
        name
        email
        phoneNumber
        customData {
          identificationType
          identificationNumber
          billing
        }
        documentId
        uid
        provider
        terms
        notifications
        shoppingCartVersion
        organizationId
        segments
        externalId
        phoneNumberValidated
      }
      address {
        id
        description
        address {
          structure
          other
        }
        addressTwo
        available
        latitude
        longitude
        city
        state
        zipCode
        removed
        customerId
      }
      store {
        id
        name
        reference
        currency
        longitude
        latitude
        address
        addressTwo
        country
        state
        zipCode
        slotSize
      }
      number
      comment
      currency
      callCenterAgent {
        name
        email
      }
      operationalModel
      clientId
      itemsQuantity
      pricesSummary {
        shippingFee
        taxes
        discounts
        subtotal
        fullPrice
        total
        totalBeforeTaxes
        taxesSummary {
          id
          name
          value
        }
      }
      expiresAt
      purchasedAt
      createdAt
      products {
        id
        quotationId
        unitQuantity
        reference
        instruction
        imageUrl
        baseUnitPrice
        baseUnitQuantity
        pricePerBaseUnit {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
        }
        conversionFactor
        unit
        baseUnit
        name
        brand
        baseUnitPriceBeforeTaxes
        price {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
        }
      }
    }
  }
`,r=e.gql`
  query GetQuotation($getQuotationInput: GetQuotationInput!) {
    getQuotation(getQuotationInput: $getQuotationInput) {
      id
      status
      customer {
        id
        name
        email
        phoneNumber
        customData {
          identificationType
          identificationNumber
          billing
        }
        documentId
        uid
        provider
        terms
        notifications
        shoppingCartVersion
        organizationId
        segments
        externalId
        phoneNumberValidated
      }
      address {
        id
        description
        address {
          structure
          other
        }
        addressTwo
        available
        latitude
        longitude
        city
        state
        zipCode
        removed
        customerId
      }
      store {
        id
        name
        reference
        currency
        longitude
        latitude
        address
        addressTwo
        country
        state
        zipCode
        slotSize
      }
      number
      comment
      currency
      callCenterAgent {
        name
        email
      }
      operationalModel
      clientId
      itemsQuantity
      pricesSummary {
        shippingFee
        taxes
        discounts
        subtotal
        fullPrice
        total
        totalBeforeTaxes
        taxesSummary {
          id
          name
          value
        }
      }
      expiresAt
      purchasedAt
      createdAt
      products {
        id
        quotationId
        unitQuantity
        reference
        instruction
        imageUrl
        baseUnitPrice
        baseUnitQuantity
        pricePerBaseUnit {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
        }
        conversionFactor
        unit
        baseUnit
        name
        brand
        baseUnitPriceBeforeTaxes
        price {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
        }
      }
    }
  }
`,s=e.gql`
  mutation UpdateQuotation($updateQuotationInput: UpdateQuotationInput!) {
    updateQuotation(updateQuotationInput: $updateQuotationInput) {
      id
      status
      customer {
        id
        name
        email
        phoneNumber
        customData {
          identificationType
          identificationNumber
          billing
        }
        documentId
        uid
        provider
        terms
        notifications
        shoppingCartVersion
        organizationId
        segments
        externalId
        phoneNumberValidated
      }
      address {
        id
        description
        address {
          structure
          other
        }
        addressTwo
        available
        latitude
        longitude
        city
        state
        zipCode
        removed
        customerId
      }
      store {
        id
        name
        reference
        currency
        longitude
        latitude
        address
        addressTwo
        country
        state
        zipCode
        operationalModelsPriority {
          DELIVERY
          PICK_AND_COLLECT
        }
        slotSize
        dynamicParams
      }
      number
      comment
      currency
      callCenterAgent {
        name
        email
      }
      operationalModel
      clientId
      itemsQuantity
      pricesSummary {
        shippingFee
        taxes
        discounts
        subtotal
        fullPrice
        total
        totalBeforeTaxes
        attributes {
          type
          name
          value
        }
        taxesSummary {
          id
          name
          value
        }
      }
      expiresAt
      purchasedAt
      products {
        id
        quotationId
        unitQuantity
        reference
        instruction
        imageUrl
        baseUnitPrice
        baseUnitQuantity
        conversionFactor
        promotion {
          type
          isActive
          conditions {
            quantity
            price
            priceBeforeTaxes
            taxTotal
            taxes {
              taxId
              taxName
              taxType
              taxValue
              taxSubTotal
            }
          }
          description
          endDateTime
          startDateTime
          isApplied
        }
        unit
        baseUnit
        name
        attributes {
          sku
          ean
          category
          location
        }
        categories {
          reference
          name
          path
          slug
          level
          boost
          isAvailableInHome
          hasChildren
          active
          categoryNamesPath
          isAssociatedToCatalog
        }
        price {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
          taxesSummary {
            id
            name
            value
            type
            rate
          }
        }
        pricePerBaseUnit {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
          taxesSummary {
            id
            name
            value
            type
            rate
          }
        }
        maxUnitQuantity
        minUnitQuantity
        stockDetails {
          storeReference
          stock
        }
        brand
        baseUnitPriceBeforeTaxes
      }
      createdAt
    }
  }
`,u=e.gql`
  mutation DuplicateQuotation(
    $duplicateQuotationInput: DuplicateQuotationInput!
  ) {
    duplicateQuotation(duplicateQuotationInput: $duplicateQuotationInput) {
      id
      status
      customer {
        id
        name
        email
        phoneNumber
        customData {
          identificationType
          identificationNumber
          billing
        }
        documentId
        uid
        provider
        terms
        notifications
        shoppingCartVersion
        organizationId
        segments
        externalId
        phoneNumberValidated
      }
      address {
        id
        description
        address {
          structure
          other
        }
        addressTwo
        available
        latitude
        longitude
        city
        state
        zipCode
        removed
        customerId
      }
      store {
        id
        name
        reference
        currency
        longitude
        latitude
        address
        addressTwo
        country
        state
        zipCode
        operationalModelsPriority {
          DELIVERY
          PICK_AND_COLLECT
        }
        slotSize
        dynamicParams
      }
      number
      comment
      currency
      callCenterAgent {
        name
        email
      }
      operationalModel
      clientId
      itemsQuantity
      pricesSummary {
        shippingFee
        taxes
        discounts
        subtotal
        fullPrice
        total
        totalBeforeTaxes
        attributes {
          type
          name
          value
        }
        taxesSummary {
          id
          name
          value
        }
      }
      expiresAt
      purchasedAt
      products {
        id
        quotationId
        unitQuantity
        reference
        instruction
        imageUrl
        baseUnitPrice
        baseUnitQuantity
        conversionFactor
        promotion {
          type
          isActive
          conditions {
            quantity
            price
            priceBeforeTaxes
            taxTotal
            taxes {
              taxId
              taxName
              taxType
              taxValue
              taxSubTotal
            }
          }
          description
          endDateTime
          startDateTime
          isApplied
        }
        unit
        baseUnit
        name
        attributes {
          sku
          ean
          category
          location
        }
        categories {
          reference
          name
          path
          slug
          level
          boost
          isAvailableInHome
          hasChildren
          active
          categoryNamesPath
          isAssociatedToCatalog
        }
        price {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
          taxesSummary {
            id
            name
            value
            type
            rate
          }
        }
        pricePerBaseUnit {
          taxes
          totalBeforeTaxes
          subtotal
          fullPrice
          discount
          total
          taxesSummary {
            id
            name
            value
            type
            rate
          }
        }
        maxUnitQuantity
        minUnitQuantity
        stockDetails {
          storeReference
          stock
        }
        brand
        baseUnitPriceBeforeTaxes
      }
      createdAt
    }
  }
`;const d="undefined"!=typeof window?a.useLayoutEffect:a.useEffect,c="undefined"!=typeof window;function l({useWindow:e,target:t}){if(!c)return{x:0,y:0};if(e)return{x:window.scrollX,y:window.scrollY};const a=t?.getBoundingClientRect?.()||{};return{x:a.left,y:a.top}}const m=({effect:e,deps:t,element:i,useWindow:o,wait:n})=>{let r=window;o||(r=i&&i.current?i.current:document.body);const s=a.useRef(l({useWindow:o,target:r}));let u=null;const m=()=>{o||(r=i&&i.current?i.current:document.body);const t=l({useWindow:o,target:r});e({prevPos:s.current,currPos:t}),s.current=t,u=null};d(()=>{if(!c)return;const e=()=>{n?null===u&&(u=setTimeout(m,n)):m()};return r.addEventListener("scroll",e),()=>{r.removeEventListener("scroll",e),u&&clearTimeout(u)}},t)};m.defaultProps={deps:[],element:!1,useWindow:!1,wait:null};const p=e.gql`
  query getDynamicHome($getDynamicHomeInput: GetDynamicHomeInput!) {
    getDynamicHome(getDynamicHomeInput: $getDynamicHomeInput)
  }
`;exports.a=({onCompleted:t,onError:a})=>{const[i]=e.useLazyQuery(p,{context:{version:"v3"},fetchPolicy:"no-cache",onCompleted:t,onError:a});return e=>{const o={getDynamicHomeInput:{...e}};i({variables:o,onCompleted:t,onError:a})}},exports.b=i,exports.c=r,exports.d=u,exports.e=s,exports.g=n,exports.m=o,exports.u=m;